export default {
  postSaCount(data) {
    if (data.options) {
      data.options = JSON.stringify(data.options);
    }
    return this.http('api', 'post', '/open-interface/v1/data/report_data', {
      name: data.type,
      param: data.options
    }).then(
      (res) => res
    ).catch(() => {

    });
  },
  getUserDiets(params) {
    return this.http('Bingo', 'get', '/api/v2/user_diets', params);
  },
  getLotteryData(id, params) {
    return this.http('Bingo', 'get', `api/v1/lottery/${id}`, params);
  },
  getLotteryAwardList(params) {
    return this.http('Bingo', 'get', 'api/v1/lottery/winners', params);
  },
  postLottery(params) {
    return this.http('Bingo', 'post', 'api/v1/lottery/play', params);
  },
  getFreeRecipe(params) {
    return this.http('Bingo', 'get', '/api/v2/food_sets', params);
  }
};
